import React, { FC } from "react";
import ReactDOM from "react-dom";
import colors from "constants/colors";

import Icon from "newComponents/Shared/_Atoms/Icons/Icon/Icon";
import Button from "newComponents/Shared/_Atoms/Buttons/Button/Button";

interface IProps {
  error?: string;
  onClose?: () => void;
}

const ErrorModal: FC<IProps> = ({ error, onClose }) => {
  return ReactDOM.createPortal(
    <div className="error-modal-overlay">
      <div className="error-modal-container">
        <div
          className="modal-header"
          style={{
            background: colors.red
          }}
        >
          <div className="header-info">
            <Icon
              icon="warning"
              style={{
                marginRight: "10px"
              }}
            />
            <div>Issue message</div>
          </div>
          <Icon
            icon="close"
            style={{
              cursor: "pointer"
            }}
            onClick={onClose}
          />
        </div>
        <div className="modal-content">
          <Icon icon="dizzy" className="error-big-icon" color={colors.red} size={64} />
          <div className="modal-content-title">Houston, We Have a Problem!</div>
          <div className="modal-content-info">{error}</div>
        </div>
        <div className="error-modal-buttons-container">
          <Button name={"Close"} onClick={onClose} />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ErrorModal;
